export default __webpack_public_path__ + "static/media/allMeters.9b9ee7e2.svg";